<div class="component-viewer">
  <mat-card>
    <mat-card-header style="display: inline;">
      <div class="d-flex justify-content-between align-items-center w-100">
        <div class="d-flex align-items-center gap-5">
          <h2 class="mb-0">Customers</h2>
        </div>
        <button mat-raised-button (click)="addMembershipCustomer()">
          Add <mat-icon>add</mat-icon>
        </button>
      </div>
    </mat-card-header>
    <mat-card-content>
      <gt-table *ngIf="true" [loading]="isLoading" [defaultPageSize]="15" [updateFilterEvent]="updateFilterEvent"
        [filter]="filter" [data]="membershipCustomers" (filterChanged)="getMembershipCustomers()" (filterReset)="resetFilter()">
      </gt-table>
      <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
      <table mat-table [dataSource]="membershipCustomers" matSort (matSortChange)="sortData($event)">
        <ng-container matColumnDef="firstName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="firstName"> First Name </th>
          <td mat-cell *matCellDef="let customer"> {{ customer.firstName }} </td>
        </ng-container>
        <ng-container matColumnDef="lastName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="lastName"> Last Name </th>
          <td mat-cell *matCellDef="let customer"> {{ customer.lastName }} </td>
        </ng-container>
        <ng-container matColumnDef="emailAddress">
          <th mat-header-cell *matHeaderCellDef> Email </th>
          <td mat-cell *matCellDef="let customer"> {{ customer.emailAddress }} </td>
        </ng-container>
        <ng-container matColumnDef="discountCode">
          <th mat-header-cell *matHeaderCellDef> Discount Code </th>
          <td mat-cell *matCellDef="let customer"> {{ customer.discountCode }} </td>
        </ng-container>
        <ng-container matColumnDef="membershipPlanName">
          <th mat-header-cell *matHeaderCellDef> Plan </th>
          <td mat-cell *matCellDef="let customer"> {{ customer.membershipPlanName }} </td>
        </ng-container>
        <ng-container matColumnDef="membershipPlanPrice">
          <th mat-header-cell *matHeaderCellDef> Plan Price </th>
          <td mat-cell *matCellDef="let customer"> {{ customer.membershipPlanPrice | currency }} </td>
        </ng-container>
        <ng-container matColumnDef="startDate">
          <th mat-header-cell *matHeaderCellDef> Start Date </th>
          <td mat-cell *matCellDef="let customer"> {{ customer.startDate | date: 'MMM d, y' }} </td>
        </ng-container>
        <ng-container matColumnDef="endDate">
          <th mat-header-cell *matHeaderCellDef> End Date </th>
          <td mat-cell *matCellDef="let customer"> {{ customer.endDate | date: 'MMM d, y' }} </td>
        </ng-container>
        <ng-container matColumnDef="isCancelled">
          <th mat-header-cell *matHeaderCellDef> Status </th>
          <td mat-cell *matCellDef="let customer">
            <mat-icon color="warn" *ngIf="customer.isCanceled" matTooltip="Canceled">cancel</mat-icon>
            <mat-icon *ngIf="!customer.isCanceled" matTooltip="Active">check_circle</mat-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let customer">
            <button mat-icon-button [matMenuTriggerFor]="actionsMenu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #actionsMenu>
              <button mat-menu-item (click)="editMembershipCustomer(customer)">
                Edit <mat-icon>edit</mat-icon>
              </button>
              <button mat-menu-item (click)="deleteMembershipCustomer(customer)">
                Delete <mat-icon>delete</mat-icon>
              </button>
              <button *ngIf="!customer.isCanceled" mat-menu-item (click)="cancelMembershipCustomer(customer)">
                Cancel <mat-icon>cancel</mat-icon>
              </button>
              <button *ngIf="customer.isCanceled" mat-menu-item (click)="renewMembershipCustomer(customer)">
                Renew <mat-icon>check_circle</mat-icon>
              </button>
            </mat-menu>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <div *ngIf="!isLoading && membershipCustomers.length === 0" class="mt-3 text-center">
        No customers found.
      </div>
    </mat-card-content>
  </mat-card>
</div>
